"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../utils");
var _lodash = require("lodash");
require("./EmergencyContactsListEditor.less");
var _EmergencyContactsListForm = _interopRequireDefault(require("./EmergencyContactsListForm"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var EmergencyContactsListEditor = function EmergencyContactsListEditor(_ref) {
  var _ref$patientId = _ref.patientId,
    patientId = _ref$patientId === void 0 ? 'me' : _ref$patientId,
    _ref$onEdited = _ref.onEdited,
    onEdited = _ref$onEdited === void 0 ? _lodash.noop : _ref$onEdited;
  var _useFetchEmergencyCon = (0, _utils.useFetchEmergencyContact)(patientId),
    contactData = _useFetchEmergencyCon.contactData,
    loading = _useFetchEmergencyCon.loading,
    refetchContacts = _useFetchEmergencyCon.refetchContacts;
  var _useUpdateEmergencyCo = (0, _utils.useUpdateEmergencyContact)({
      patientId: patientId,
      handleSuccess: function handleSuccess() {
        refetchContacts();
        onEdited();
      },
      handleErrors: function handleErrors() {
        refetchContacts();
      }
    }),
    handleSubmit = _useUpdateEmergencyCo.handleSubmit,
    processing = _useUpdateEmergencyCo.processing;
  var handleContactSubmit = function handleContactSubmit(values) {
    handleSubmit(values);
  };
  if (loading || processing) {
    return /*#__PURE__*/_react.default.createElement(_spin.default, {
      size: "large",
      className: "flex justify-center py-[100px]"
    });
  }
  if (contactData) {
    return /*#__PURE__*/_react.default.createElement(_EmergencyContactsListForm.default, {
      contact: contactData,
      onSubmit: handleContactSubmit
    });
  }
  return null;
};
var _default = EmergencyContactsListEditor;
exports.default = _default;